@use "~theme/breakpoints";

$width: 375px;

// Note: opacity is managed as an inline style in the React component

.container {
  position: fixed; /* Sit on top of the screen */
  top: 0;
  padding: 12px;
  visibility: hidden;
  transition: top 250ms, opacity 250ms, visibility 250s;
  z-index: 9999;

  @include breakpoints.desktop {
    left: 50%; /* Center the toast */
    max-width: $width;
    margin-left: calc(#{$width} / -2); /* Divide value of min-width by 2 */
  }
}

.toast {
  position: relative;
  box-shadow: 0 6px 20px var(--black-at-75);
  background-color: var(--canvas-tan);
  color: var(--brand-indigo);
  border-radius: 4px;
}

.visible {
  top: 40%;
  visibility: visible;

  @include breakpoints.desktop {
    top: 30px;
  }
}
